export default function TableHeader({ children }) {
  return <thead className={'bidder-table-header'}>{children}</thead>;
}
